import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class LocalStore {
  public get<T extends string>(key: string): T | null {
    return localStorage.getItem(key) as T | null;
  }

  public set(key: string, value: string): void {
    localStorage.setItem(key, value);
  }

  public remove(key: string): void {
    localStorage.removeItem(key);
  }
}
